import * as React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import {
  Avatar,
  Box,
  Divider,
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";

import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

const Versions = (props: {
  versionOpenState: boolean;
  // setVersionOpenState: boolean;
  setVersionOpenState: (_0: boolean) => void;
  versionLists: any[];
  downloadHandler: (version: string) => void;
}) => {
  const { versionOpenState, setVersionOpenState, versionLists = [], downloadHandler } = props;


  const sortedVersionLists = React.useMemo(() => {
    return [...versionLists].sort((a, b) => Number(b.ReleaseID) - Number(a.ReleaseID));
  }, [versionLists]);

  // console.log(sortedVersionLists,?)

  // const [submitState, setSubmitState] = React.useState(false);

  // console.log("versionLists", versionLists);

  const onSubmit = (data: any) => {
    setVersionOpenState(false);

    // setTimeout(() => {
    //   setFormOpenState(false);
    //   setSubmitState(false)
    // }, 4000);
  };

  const handleClose = () => {
    setVersionOpenState(false);
  };

  return (
    <div>
      <Dialog open={versionOpenState} onClose={handleClose}>
        <DialogTitle>Versions</DialogTitle>
        <DialogContent>
          <Grid sx={{ width: "100%", textAlign: "center" }}>
            <TableContainer component={Box} sx={{ mt: 1, width: "500px" }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ fontWeight: "bold" }}>
                      Version Name
                    </TableCell>
                    <TableCell sx={{ fontWeight: "bold" }}>
                      Release Date
                    </TableCell>
                    <TableCell sx={{ fontWeight: "bold" }} align="center">Download</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {sortedVersionLists && sortedVersionLists.map((version, index) => (
                    <TableRow
                    key={index}
                    sx={{
                      height: "30px", // Reduce row height
                      backgroundColor: index === 0 ? "#f5f5f5" : "inherit", // Highlight first row
                    }}
                    >
                    <TableCell>{version.VersionName.split('_')[1]}</TableCell>
                    <TableCell>{version.ReleaseDate}</TableCell>
                    <TableCell align="center">
                      <IconButton
                      onClick={downloadHandler.bind(this, version.VersionName)}
                      aria-label="Download Extension"
                      sx={{
                        bgcolor: "#3A3A3A",
                        width: "20px",
                        height: "20px",
                        borderRadius: "5px",
                        "&:hover": {
                        bgcolor: "#3a3a3ae3",
                        },
                      }}
                      >
                      <Avatar
                        sx={{
                        width: "15px",
                        height: "15px",
                        }}
                        src={"/assets/icons/Download.svg"}
                      />
                      </IconButton>
                    </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
          {/* )} */}
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default Versions;
